import React from "react";
const Footer = () => (
    <footer>
        <h1>Information is sourced from developer.mozilla.org</h1>
        <div>
            It is intended for casual informational use. For proper practical
            information about the web APIs visit
            developer.mozilla.org/en-US/docs/Web/API
        </div>
        <div>
            Due to the limited support for browser APIs among browsers this site
            might not work on your specific device or browser.
        </div>
    </footer>
);

export default Footer;
